import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UpdatePlayerProps, updatePlayer } from '../API';
import { playersQueryKey } from './useGetPlayers';
import { challengeQueryKey } from './useGetChallenge';

export function useUpdatePlayer(onError?) {
  const queryClient = useQueryClient();

  return useMutation<void, Error, UpdatePlayerProps>({
    mutationFn: updatePlayer,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [playersQueryKey], refetchType: 'all' });
      queryClient.invalidateQueries([challengeQueryKey]);
    },
    onError,
  });
}
